import { LogoCloudCarousel } from "../../../../modules/content/components/LogoCloudCarousel/LogoCloudCarousel";
import { LogoCloudGrid } from "../../../../modules/content/components/LogoCloudGrid/LogoCloudGrid";
import { SproutCommonContent } from "../../../../modules/content/components/SproutCommonContent/SproutCommonContent";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import type { ILogoCloudBlockProps } from "./LogoCloudBlock.props";

export const LogoCloudBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
  variant,
}: ILogoCloudBlockProps) => {
  if (!items?.length) return null;
  return (
    <SproutSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8">
        <SproutCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        {variant === "carousel" ? (
          <LogoCloudCarousel items={items} />
        ) : (
          <LogoCloudGrid items={items} />
        )}
      </div>
    </SproutSection>
  );
};

LogoCloudBlock.displayName = "Block::LogoCloudBlock";
